import React, { useState } from "react";
import Spinner from "carbon-react/lib/components/loader";
import { useUserApi } from "../../../../services/UserApi";
import InfoMessage from "../../../messages/InfoMessage";
import RefreshTokenCard from "./RefreshTokenCard";
import CommentsDialog from "../../../common/CommentsDialog";
import ErrorMessage from "../../../messages/ErrorMessage";
import DataLoadHeader from "../../../common/dataLoadHeader/DataLoadHeader";

const UserRefreshTokens = ({ user }) => {
  const [errorMsg, setErrorMsg] = useState(null);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [refreshTokens, setRefreshTokens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [commentsDialogState, setCommentsDialogState] = useState(null);
  const [commentsDialogOpen, setCommentsDialogOpen] = useState(false);
  const [showNoTokensInfoBanner, setShowNoTokensInfoBanner] = useState(false);
  const { fetchDeviceCredentials } = useUserApi();

  const onLoadRefreshTokens = async () => {
    await getRefreshTokens();
  };

  const clearError = () => {
    setErrorMsg(null);
    setShowErrorMsg(false);
  };

  const showError = (msg) => {
    setErrorMsg(msg);
    setShowErrorMsg(true);
  };

  const onError = (error) => {
    let msg = error?.toString();
    if (!msg || msg.length === 0) msg = "Operation failed";
    showError(msg);
  };

  const onDeviceCredentialDeleted = async () => {
    //  Refresh enrollments
    await getRefreshTokens();
  };

  const getRefreshTokens = async () => {
    try {
      setShowNoTokensInfoBanner(false);
      setLoading(true);
      clearError();

      const result = await fetchDeviceCredentials(user?.userId);

      if (!result.success)
        throw new Error(
          result.error?.description || "Failed to fetch refresh tokens"
        );

      setRefreshTokens(result.data?.devices);
      setShowNoTokensInfoBanner(
        result.data?.devices && result.data?.devices.length === 0
      );
    } catch (error) {
      onError(error);
    }
    setLoading(false);
  };

  const openCommentsDialog = (dialogState) => {
    setCommentsDialogState(dialogState);
    setCommentsDialogOpen(true);
  };

  const onCommentsDialogClose = () => {
    setCommentsDialogState(null);
    setCommentsDialogOpen(false);
  };

  const noRefreshTokensInfoBanner = (
    <>
      {showNoTokensInfoBanner ? (
        <InfoMessage message="User has no Refresh Tokens" />
      ) : null}
    </>
  );

  const refreshTokenCards = (
    <>
      {!showNoTokensInfoBanner &&
      refreshTokens &&
      refreshTokens.length > 0 &&
      !loading ? (
        <div className="flex-wrap-card-container">
          {refreshTokens.map((refreshToken) => {
            return (
              <RefreshTokenCard
                user={user}
                refreshToken={refreshToken}
                onDeviceCredentialDeleted={onDeviceCredentialDeleted}
                openCommentsDialog={openCommentsDialog}
                busy={loading}
                onError={onError}
              />
            );
          })}
        </div>
      ) : null}
    </>
  );

  const pageBody = (
    <>
      {refreshTokenCards}
      {noRefreshTokensInfoBanner}
    </>
  );

  const dataLoadHeader = (
    <DataLoadHeader onLoad={onLoadRefreshTokens} appearBusy={loading} />
  );

  if (!user) return null;

  return (
    <>
      {dataLoadHeader}
      {showErrorMsg ? (
        <ErrorMessage message={errorMsg || "The operation failed"} />
      ) : (
        <>{pageBody}</>
      )}
      <CommentsDialog
        dialogState={commentsDialogState}
        open={commentsDialogOpen}
        onClose={onCommentsDialogClose}
      />
    </>
  );
};

export default UserRefreshTokens;
